import React from 'react';
import { View } from 'react-native';

import { makeStyles } from '@providers/Theme';

import { Elmenus } from './Elmenus';
import { Logo } from './Logo';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
}));

export const LogoPlusElmenus: React.FC<{ testID: string }> = ({ testID }) => {
  const styles = useStyles();

  return (
    <View style={styles.root} testID={testID}>
      <Logo height={32} testID="logo" />
      <Elmenus height={32} width={108} marginLeft={10} testID="elmenus" />
    </View>
  );
};
